import * as React from 'react';

const Hr16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#D52B1E", d: "M1.127 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1.333h-14z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M1.127 6.333h14v3.334h-14z" }), /* @__PURE__ */ React.createElement("path", { fill: "#002395", d: "M1.127 9.667h14V11a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#D52B1E",
    d: "M5.72 6.252V8.95c0 1.27 1.022 2.3 2.284 2.3a2.29 2.29 0 0 0 2.285-2.3V6.252z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F1F2F1",
    d: "M6.705 6.864h.866v.872h-.866zm.867.872h.865v-.872h.867v.872h-.867l.001.871h.865v.872h-.866l.001-.872h-.866zm.866 2.986c.267-.065.515-.195.727-.371h-.727v-.872h-.866v.872h.866zm1.299-1.243a1.75 1.75 0 0 1-.432.751v-.751zm-3.465 0c.083.287.23.547.433.751v-.751zM6.18 7.736h.525v.871H6.18zm3.65 0h-.525v.871h.525zm-3.125.871h.866v.872h-.866zm.867 2.115a1.76 1.76 0 0 1-.728-.371h.728z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#171796",
    d: "m6.807 4.852-.47.593.304 1.113c.295-.083.903-.157.903-.157l-.102-1.15z"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#0193DD", d: "M5.646 5.167 5.25 5.9l.47 1.01.921-.343-.304-1.122-.69-.278Z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#171796",
    d: "m9.202 4.852-.636.399-.083 1.15c.286.027.894.167.894.167l.295-1.122-.46-.594z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#0193DD",
    d: "m10.363 5.167-.7.278-.295 1.122c.295.084.912.343.912.343l.47-1.01zM8.005 4.75l-.562.5.102 1.15c.248-.018.93 0 .93 0l.083-1.15-.562-.5h.01Z"
  }
));
Hr16.Size = 16;
Hr16.Title = "Hr";

export { Hr16 as default };
